/**
 * Controle van screen size en verwijderen van overlay op grote schermen.
 */

import toggleOverlay from "./toggleOverlay";
import { showFacetFilters } from "../reducers";

export default function checkScreenSize() {
	return (dispatch) => {
		const facets = document.querySelector(".js-facets");
		if (facets) {
			window.addEventListener("resize", () => {
				const facetsStyle = getComputedStyle(facets);
				if ("static" === facetsStyle.getPropertyValue("position")) {
					toggleOverlay(false);
					dispatch(showFacetFilters(false));
				}
			});
		}
	};
}
